module.exports = __webpack_public_path__ + "img/taxi-bus.37aa502c.svg";